import { ComponentProps, forwardRef } from "react";
import classNames from "classnames";
import styles from "./NativeSelect.module.scss";

type NativeSelectProps = ComponentProps<"select">;

// Bare native <select> inside InputCore's content area — no border/chevron of its own; the
// chevron is composed by the consumer via InputCore's trailingSlot.
const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
	({ className, children, ...props }, ref) => {
		return (
			<select ref={ref} className={classNames(styles["native-select"], className)} {...props}>
				{children}
			</select>
		);
	}
);

NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
